angular.module('common.directives').directive('edgeReport', function () {
  return {
    scope: {
      edge: '='
    },
    templateUrl: './templates/edgeReports.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'edgeReportsController'
  }
})
